import React from 'react';
import PropTypes from 'prop-types';

export const RoutesIntelinkBlocks = ({ trainRouteProps: { source, destination, url, label, idx } }) => {
  return (
    <li key={`${source}_${destination}_${idx}`} className="appendBottom10">
      <a href={url} className="font14 darkGreyText railSeoWrap__rwStnListLink" target="_blank" rel="noreferrer">
        {label}
      </a>
    </li>
  );
};

RoutesIntelinkBlocks.propTypes = {
  trainRouteProps: PropTypes.object
};

export default RoutesIntelinkBlocks;
